<script>
    import IDWPlot from "./IDWPlot.svelte";

    import { onMount } from "svelte";
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    
    import * as d3 from "d3";

    export let data;
    export let accessor_x = (d) => d[0];
    export let accessor_y = (d) => d[1];
    export let accessor_label = (d, i) => null;
    export let accessor_img = () => null;
    export let colorscaleLabel;

    export let width = 350;
    export let height = 350;

    export let point_style = "rect";

    export let margin = 20;
    export let w = 10;

    export let showIDW = false;
    export let valuesIDW = null;
    export let scaleIDW = false;
    export let typeIDW = "idw";
    export let withTitle = false;
    
    let svg;

    $: values = data.map(d => [accessor_x(d), accessor_y(d)]);
    

    function get_scales(data) {
        return [
            d3.scaleLinear().domain(d3.extent(values, d => d[0])).range([margin, width - margin]),
            d3.scaleLinear().domain(d3.extent(values, d => d[1])).range([margin, height - margin])
        ]
    }

    $: [x, y] = get_scales(data);

    let loading = true;
    onMount(() => {
        loading = false;
    })

    function clicked(d, i) {
        dispatch("click", {
            index: i,
        })
    }
</script>

<div class:IDW={showIDW}>
    {#if !loading && showIDW}
        <IDWPlot 
            xpos={values.map(d => x(d[0]))}
            ypos={values.map(d => y(d[1]))} 
            width={width} 
            height={height} 
            values={valuesIDW}
            value_scale={scaleIDW}
            dr_scale={colorscaleLabel}
            type={typeIDW}
        />
    {/if}
    <svg 
        bind:this={svg} 
        width={width} 
        height={height} 
        class:SP={point_style != "rect"}
        on:click={() => {
            if (point_style != "rect") dispatch("click")
        }}>
    
        {#if point_style == "rect"}
            {#each values as d, i}
                <rect 
                    x={x(d[0]) - w/2}
                    y={y(d[1]) - w/2}
                    width={w}
                    height={w}
                    fill={colorscaleLabel(accessor_label(d, i))}
                    stroke="white"
                    on:click={() => clicked(d, i)}
                >
                    <title>{data[i].dr} ({data[i].name.split(data[i].dr)[1].split(["_"]).filter(d => d).join(", ")}) — model ranking: {d3.format(".2f")(valuesIDW[i])}</title>        
                </rect>
            {/each}
        {:else if point_style == "circle"}
            {#each values as d, i}
                <circle 
                    cx={x(d[0]) - w/2}
                    cy={y(d[1]) - w/2}
                    r={w}
                    fill={colorscaleLabel(accessor_label(d, i))}
                >      
                    {#if withTitle}
                        <title>{data[i]?.filename}</title>
                    {/if}
                </circle>
            {/each}
        {:else if point_style == "img"}
            {#each values as d, i}
                <rect
                    x={x(d[0]) - w - 2}
                    y={y(d[1]) - w - 2}
                    width={w * 2 + 4}
                    height={w * 2 + 4}
                    fill={colorscaleLabel(accessor_label(d, i))}>
                </rect>
                <rect
                    x={x(d[0]) - w}
                    y={y(d[1]) - w}
                    width={w * 2}
                    height={w * 2}
                    fill="white">
                </rect>
                <image 
                    x={x(d[0]) - w}
                    y={y(d[1]) - w}
                    width={w * 2}
                    height={w * 2}
                    xlink:href={accessor_img(d, i)}
                >
                    {#if withTitle}
                        <title>{data[i]?.filename}</title>
                    {/if}
                </image>
            {/each}
        {/if}
    </svg>
</div>


<style>
    .IDW {
        position: relative;
        margin: 1rem;
    }

    .IDW > svg {
        position: absolute;
        top: 0;
        left: 0;
    }

    .SP {
        background-color: #3333;
        border-radius: 1rem;
    }
</style>